/**
 * @file 混入 - 核心功能
 * @author hardylin <hardylin@tencent.com>
 */
import { BUCKEY } from 'scripts/constants/cloud'

export default {
    computed: {
        mGame() {
            return this.$store.state.global.game
        },

        mGameInfo() {
            return this.$store.state.global.gameInfo
        },

        mConfig() {
            return this.$store.state.global.config
        }
    },

    methods: {

        /**
         * 返回规范颜色值
         * @param {Number} index - 配色规范色号
         * @param {Number} [opacity = 1] - 透明度
         */
        mColor(index, opacity = 1) {
            const { color } = this.$store.state.global.config.theme
            if (Number.isInteger(index)) {
                return color[index]
            } else {
                index = index.toString()
                switch (index) {
                    case '2.1':
                        opacity = 0.65
                        break
                    case '3.1':
                        opacity = 0.5
                        break
                    case '4.1':
                        opacity = 0.9
                        break
                    case '8.1':
                        opacity = 0.6
                        break
                    case '8.2':
                        opacity = 0.3
                        break
                    case '15.1':
                        opacity = 0.8
                        break
                }
                let str = color[index.split('.')[0]]
                return str.includes('#') ? `rgba(${ Number.parseInt(str.substr(1, 2), 16) }, ${ Number.parseInt(str.substr(3, 2), 16) }, ${ Number.parseInt(str.substr(5, 2), 16) }, ${ opacity })` : str.replace('1)', opacity + ')')
            }
        },

        /**
         * 一像素分割线
         * @param {Number} index - 配色规范色号
         * @param {String} position - 边框位置
         * @param {Number} backgroundIndex - 背景色规范色号
         */
        mBackground(index, position, backgroundIndex) {
            let color = this.mColor(index)
            let background = ''
            switch (position) {
                case 'top':
                    background = `linear-gradient(0deg, transparent, transparent 50%, ${ color } 50%) repeat-x top / 1px 1px`
                    break
                case 'right':
                    background = `linear-gradient(90deg, transparent, transparent 50%, ${ color } 50%) repeat-y right / 1px 1px`
                    break
                case 'bottom':
                    background = `linear-gradient(transparent, transparent 50%, ${ color } 50%) repeat-x bottom / 1px 1px`
                    break
                case 'left':
                    background = `linear-gradient(270deg, transparent, transparent 50%, ${ color } 50%) repeat-y left / 1px 1px`
                    break
            }
            return backgroundIndex ? this.mColor(backgroundIndex) + ' ' + background : background
        },

        /**
         * 事件埋点
         * @param {String} event - 事件
         * @param {String} name - 名称
         * @param {Object} [params] - 埋点额外参数
         * @param {Object} [params.id] - 埋点额外参数：唯一标识
         */
        mEventTracking(event, name, params = {}) {

            // Mosso
            if (typeof PTTSendClick == 'function') {
                let eventArr = event.split('_')
                if (params.id) { // tab id
                    eventArr[1] = eventArr[1] + '_' + params.id
                } else if (params.keyword) { // 搜索关键字
                    eventArr[1] = eventArr[1] + '_' + params.keyword
                }
                PTTSendClick(eventArr[0], eventArr[1], name, `${ this.changeGameName() }.qq.com/ingame${ this.$route.path }`)
            }
        },

        /**
         * Mosso 事件埋点
         * @param {String} module - 模块
         * @param {String} event - 事件
         * @param {String} name - 名称
         */
        mEventTrackingToMosso(module, event, name) {
            if (typeof PTTSendClick == 'function') {
                PTTSendClick(module, event, name, `${ this.changeGameName() }.qq.com/ingame${ this.$route.path }`)
            }
        },

        changeGameName(){
            return this.mGame == 'srpg' ? 'war' : this.mGame
        },

        /**
         * 获取指定名称的 url 参数
         * @param {String} name - 参数名称
         * @param {String} url - 指定 url，不指定默认为当前页面 url
         * @returns {String} - 参数的值，未找到则返回 null
         */
        mGetUrlParam(name, url) {
            const reg = new RegExp('(\\?|&)' + name + '=([^&#]*)')
            const result = reg.exec(url ? url : location.href)
            return result != null ? decodeURIComponent(result[2]) : null
        },

        /**
         * url 转为 https
         * @param {String} url - 资源地址
         * @returns {String} - 转为 https 协议头后的 url
         */
        mHttps(url) {
            return url ? url.replace(/／/g, '/')
                .replace(/＆/g, '&')
                .replace(/＝/g, '=')
                .replace(/^(https?:)?\/\//g, 'https://') : ''
        },

        matchUrl(url) {
            return /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i.test(url);
        },
        /**
         * 为 URL 拼接登录态
         * @param {String} url - 要处理的 url
         * @returns {String} - 带登录态的 URL
         */
        mAddTokenParams(url) {
            if (!url) {
                return ''
            }
            url = decodeURIComponent(url).replace(/javascript/g,'*').replace(/\'|\"|\(|\)|\<|\>|\`/g,'*');
            const { tokenParams } = sessionStorage;
            if (!tokenParams) {
                return url
            }
            const arr = url.split('#')
            let newUrl = arr[0].includes('?') ? arr[0] + tokenParams.replace('?', '&') : arr[0] + tokenParams;
            newUrl = newUrl.replace("gameid_v5=", "gameid=");
            return arr[1] ? newUrl + '#' + arr[1] : newUrl
        },

        /**
         * 处理 url，最终转为 https
         * @param {String} url - url
         * @returns {String} - 处理后且带 https 协议头的 url
         */
        mDealURL(url) {
            return url ? url.replace(/／/g, '/')
                .replace(/＆/g, '&')
                .replace(/＝/g, '=')
                .replace(/^(https?:)?\/\//g, 'https://') : ''
        },

        /**
         * 使用数据万象对图片进行处理，文档：https://cloud.tencent.com/document/product/460/6929
         * @param {String} url - 需要处理的 url
         * @param {String} rule - 图片处理规则，不包括 format
         * @param {Boolean} format - 是否按需将 png, webp 格式转换为 jpg
         */
        mImageView(url, rule = '', format = true) {
            if (!url) {
                return ''
            }

            url = this.mDealURL(url)

            /* #region 第三方图片转发 */
            if (/^https:\/\/itea-cdn\.qq\.com\//.test(url)) {
                url = url.replace('itea-cdn.qq.com', `${ /doujin/.test(this.$route.name) ? BUCKEY.DOUJIN : BUCKEY.V4ITEA }.image.myqcloud.com`)
            }
            if (/^https:\/\/shp\.qpic\.cn\//.test(url)) {
                url = url.replace('shp.qpic.cn', `${ BUCKEY.V4 }.image.myqcloud.com`)
            }
            if (/^https:\/\/ossweb-img\.qq\.com\//.test(url)) {
                url = url.replace('ossweb-img.qq.com', `${ BUCKEY.OSSWEB }.image.myqcloud.com`)
            }
            if (/^https:\/\/1254960240\.vod2\.myqcloud\.com\//.test(url)) {
                url = url.replace('1254960240.vod2.myqcloud.com', `${ BUCKEY.VOD }.image.myqcloud.com`)
            }
            /* #endregion */

            // 只处理腾讯云图片
            if (/myqcloud\.com/.test(url)) {

                // 移除所有参数
                url = url.replace(/cos.[^\.]+/, 'image')
                    .replace(/\?.*/, '')

                // 没有显式包含 q 规则，则图片质量统一设置为 70%
                rule = /\/q\//.test(rule) ? rule : rule + '/q/70'
                
                const suffix = url.match(/\.([0-9a-zA-Z]+)(\?|$)/)
                if (Array.isArray(suffix)) {
                    switch (suffix[1]) {
                        case 'bmp':
                            rule = rule + '/format/jpg'
                            break
                        case 'gif':
                        case 'jpeg':
                        case 'jpg':

                            // 使用默认规则

                            break
                        case 'png':
                            rule = format ? rule + '/format/jpg' : rule
                            break
                        case 'webp':
    
                            // 按需自动转换 iOS 下的 webp 格式图片
                            if (sessionStorage.igPlatform == 'ios') {
                                rule = rule + (format ? '/format/jpg' : '/format/png')
                            }
    
                            break
                        default:
    
                            // 其他格式不处理
                            rule = ''
    
                            break
                    }
                }
                if (rule) {
                    url = url + '?imageView2' + rule
                }
            }

            return url
        },
    }
}
